"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownMenu = DropdownMenu;
exports.DropdownMenuCheckboxItem = DropdownMenuCheckboxItem;
exports.DropdownMenuContent = DropdownMenuContent;
exports.DropdownMenuGroup = DropdownMenuGroup;
exports.DropdownMenuItem = DropdownMenuItem;
exports.DropdownMenuLabel = DropdownMenuLabel;
exports.DropdownMenuPortal = DropdownMenuPortal;
exports.DropdownMenuRadioGroup = DropdownMenuRadioGroup;
exports.DropdownMenuRadioItem = DropdownMenuRadioItem;
exports.DropdownMenuSeparator = DropdownMenuSeparator;
exports.DropdownMenuShortcut = DropdownMenuShortcut;
exports.DropdownMenuSub = DropdownMenuSub;
exports.DropdownMenuSubContent = DropdownMenuSubContent;
exports.DropdownMenuSubTrigger = DropdownMenuSubTrigger;
exports.DropdownMenuTrigger = DropdownMenuTrigger;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@design/lib/utils");
var _radixUi = require("radix-ui");
var _materialSymbols = require("@design/icons/material-symbols");
var _checkbox = require("@design/ui/checkbox");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "align", "sideOffset"],
  _excluded2 = ["className", "inset", "variant"],
  _excluded3 = ["className", "children", "checked", "inset"],
  _excluded4 = ["className", "children", "inset"],
  _excluded5 = ["className", "inset"],
  _excluded6 = ["className"],
  _excluded7 = ["className"],
  _excluded8 = ["className", "inset", "children"],
  _excluded9 = ["className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function DropdownMenu(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.Root, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu"
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.Root",
    "data-sentry-component": "DropdownMenu",
    "data-sentry-source-file": "dropdown-menu.tsx"
  }));
}
function DropdownMenuPortal(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.Portal, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-portal"
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.Portal",
    "data-sentry-component": "DropdownMenuPortal",
    "data-sentry-source-file": "dropdown-menu.tsx"
  }));
}
function DropdownMenuTrigger(_ref3) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.Trigger, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-trigger"
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.Trigger",
    "data-sentry-component": "DropdownMenuTrigger",
    "data-sentry-source-file": "dropdown-menu.tsx"
  }));
}
function DropdownMenuContent(_ref4) {
  var className = _ref4.className,
    _ref4$align = _ref4.align,
    align = _ref4$align === void 0 ? "start" : _ref4$align,
    _ref4$sideOffset = _ref4.sideOffset,
    sideOffset = _ref4$sideOffset === void 0 ? 4 : _ref4$sideOffset,
    props = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.Portal, {
    "data-sentry-element": "DropdownMenuPrimitive.Portal",
    "data-sentry-component": "DropdownMenuContent",
    "data-sentry-source-file": "dropdown-menu.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.Content, _objectSpread(_objectSpread({
      "data-slot": "dropdown-menu-content",
      sideOffset: sideOffset,
      align: align,
      className: (0, _utils.cn)("z-floating max-h-(--radix-dropdown-menu-content-available-height) w-(--radix-dropdown-menu-trigger-width) min-w-32 origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-(--component-base-menu-content-radius) bg-popover p-(--component-dropdown-menu-padding) text-popover-foreground shadow-md ring-1 ring-black/5 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:overflow-hidden data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className)
    }, props), {}, {
      "data-sentry-element": "DropdownMenuPrimitive.Content",
      "data-sentry-source-file": "dropdown-menu.tsx"
    }))
  });
}
function DropdownMenuGroup(_ref5) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref5), _ref5));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.Group, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-group"
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.Group",
    "data-sentry-component": "DropdownMenuGroup",
    "data-sentry-source-file": "dropdown-menu.tsx"
  }));
}
function DropdownMenuItem(_ref6) {
  var className = _ref6.className,
    inset = _ref6.inset,
    _ref6$variant = _ref6.variant,
    variant = _ref6$variant === void 0 ? "default" : _ref6$variant,
    props = _objectWithoutProperties(_ref6, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.Item, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-item",
    "data-inset": inset,
    "data-variant": variant,
    className: (0, _utils.cn)("group/dropdown-menu-item relative flex cursor-default items-center gap-(--component-base-menu-item-gap) rounded-(--component-base-menu-item-radius) p-(--component-dropdown-menu-item-padding-default) text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-8 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 data-[variant=destructive]:*:[svg]:text-destructive", className)
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.Item",
    "data-sentry-component": "DropdownMenuItem",
    "data-sentry-source-file": "dropdown-menu.tsx"
  }));
}
function DropdownMenuCheckboxItem(_ref7) {
  var className = _ref7.className,
    children = _ref7.children,
    checked = _ref7.checked,
    inset = _ref7.inset,
    props = _objectWithoutProperties(_ref7, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_radixUi.DropdownMenu.CheckboxItem, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-checkbox-item",
    "data-inset": inset,
    className: (0, _utils.cn)("relative flex cursor-default items-center gap-(--component-base-menu-item-gap) rounded-(--component-base-menu-item-radius) p-(--component-dropdown-menu-item-padding-default) text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-inset:pl-8 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className),
    checked: checked
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.CheckboxItem",
    "data-sentry-component": "DropdownMenuCheckboxItem",
    "data-sentry-source-file": "dropdown-menu.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.Checkbox, {
      checked: checked,
      tabIndex: -1,
      "aria-hidden": true,
      className: "pointer-events-none",
      "data-slot": "dropdown-menu-checkbox-item-indicator",
      "data-sentry-element": "Checkbox",
      "data-sentry-source-file": "dropdown-menu.tsx"
    }), children]
  }));
}
function DropdownMenuRadioGroup(_ref8) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref8), _ref8));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.RadioGroup, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-radio-group"
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.RadioGroup",
    "data-sentry-component": "DropdownMenuRadioGroup",
    "data-sentry-source-file": "dropdown-menu.tsx"
  }));
}
function DropdownMenuRadioItem(_ref9) {
  var className = _ref9.className,
    children = _ref9.children,
    inset = _ref9.inset,
    props = _objectWithoutProperties(_ref9, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_radixUi.DropdownMenu.RadioItem, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-radio-item",
    "data-inset": inset,
    className: (0, _utils.cn)("relative flex cursor-default items-center gap-(--component-base-menu-item-gap) rounded-(--component-base-menu-item-radius) p-(--component-dropdown-menu-item-padding-default) pr-8 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-8 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className)
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.RadioItem",
    "data-sentry-component": "DropdownMenuRadioItem",
    "data-sentry-source-file": "dropdown-menu.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "pointer-events-none absolute right-2 flex items-center justify-center",
      "data-slot": "dropdown-menu-radio-item-indicator",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.ItemIndicator, {
        "data-sentry-element": "DropdownMenuPrimitive.ItemIndicator",
        "data-sentry-source-file": "dropdown-menu.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
          "data-sentry-element": "CheckIcon",
          "data-sentry-source-file": "dropdown-menu.tsx"
        })
      })
    }), children]
  }));
}
function DropdownMenuLabel(_ref0) {
  var className = _ref0.className,
    inset = _ref0.inset,
    props = _objectWithoutProperties(_ref0, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.Label, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-label",
    "data-inset": inset,
    className: (0, _utils.cn)("px-(--component-dropdown-menu-label-px) pt-(--component-dropdown-menu-label-py) pb-(--component-dropdown-menu-label-pb) text-xs font-normal text-foreground-tertiary data-inset:pl-8", className)
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.Label",
    "data-sentry-component": "DropdownMenuLabel",
    "data-sentry-source-file": "dropdown-menu.tsx"
  }));
}
function DropdownMenuSeparator(_ref1) {
  var className = _ref1.className,
    props = _objectWithoutProperties(_ref1, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.Separator, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-separator",
    className: (0, _utils.cn)("-mx-1 my-1 h-px bg-border", className)
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.Separator",
    "data-sentry-component": "DropdownMenuSeparator",
    "data-sentry-source-file": "dropdown-menu.tsx"
  }));
}
function DropdownMenuShortcut(_ref10) {
  var className = _ref10.className,
    props = _objectWithoutProperties(_ref10, _excluded7);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-shortcut",
    className: (0, _utils.cn)("ml-auto text-xs tracking-widest text-muted-foreground group-focus/dropdown-menu-item:text-accent-foreground", className)
  }, props), {}, {
    "data-sentry-component": "DropdownMenuShortcut",
    "data-sentry-source-file": "dropdown-menu.tsx"
  }));
}
function DropdownMenuSub(_ref11) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref11), _ref11));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.Sub, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-sub"
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.Sub",
    "data-sentry-component": "DropdownMenuSub",
    "data-sentry-source-file": "dropdown-menu.tsx"
  }));
}
function DropdownMenuSubTrigger(_ref12) {
  var className = _ref12.className,
    inset = _ref12.inset,
    children = _ref12.children,
    props = _objectWithoutProperties(_ref12, _excluded8);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_radixUi.DropdownMenu.SubTrigger, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-sub-trigger",
    "data-inset": inset,
    className: (0, _utils.cn)("flex cursor-default items-center gap-(--component-base-menu-item-gap) rounded-(--component-base-menu-item-radius) p-(--component-dropdown-menu-item-padding-default) text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-8 data-open:bg-accent data-open:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className)
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.SubTrigger",
    "data-sentry-component": "DropdownMenuSubTrigger",
    "data-sentry-source-file": "dropdown-menu.tsx",
    children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
      className: "ml-auto",
      "data-sentry-element": "ChevronRightIcon",
      "data-sentry-source-file": "dropdown-menu.tsx"
    })]
  }));
}
function DropdownMenuSubContent(_ref13) {
  var className = _ref13.className,
    props = _objectWithoutProperties(_ref13, _excluded9);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.DropdownMenu.SubContent, _objectSpread(_objectSpread({
    "data-slot": "dropdown-menu-sub-content",
    className: (0, _utils.cn)("z-floating min-w-[96px] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-md bg-popover p-1 has-data-[slot=command]:p-0 text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className)
  }, props), {}, {
    "data-sentry-element": "DropdownMenuPrimitive.SubContent",
    "data-sentry-component": "DropdownMenuSubContent",
    "data-sentry-source-file": "dropdown-menu.tsx"
  }));
}